<ng-container *ngIf="(show | async) == true">
  <div class="box">
    <div class="messages">
      <div *ngFor="let message of messages | async">{{message}}</div>
    </div>
    <button class="actions" mat-stroked-button color="primary" (click)="close()">Schliessen</button>
  </div>
</ng-container>
